import { DefineComponent } from 'vue';

export type FormPaths = [
    Record<string, () => Promise<DefineComponent>>,
    string,
];

const formsPaths: FormPaths[] = [
    [
        import.meta.glob<DefineComponent>(
            '/vendor/kibokosrl/kiboko-backoffice-core/resources/js/Components/Forms/**/*.vue',
        ),
        '/vendor/kibokosrl/kiboko-backoffice-core/resources/js/Components/Forms/',
    ],
];

export default formsPaths;
